// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"001ef540","977":"068ca579"}[chunkId] + ".chunk.js";
};